(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1239],{

/***/ 96646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ formatCurrency; }
/* harmony export */ });
/* unused harmony export formatBankString */
const formatCurrency = (number)=>new Intl.NumberFormat("id-ID").format(number);
const formatBankString = (str)=>{
    try {
        str.split("_").map((s)=>{
            return s[0].toUpperCase() + s.substring(1).toLowerCase();
        }).join(" ");
    } catch  {
        return "";
    }
};


/***/ }),

/***/ 57818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "VideoJS": function() { return /* binding */ VideoJS; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36734);
/* harmony import */ var lib_const__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5173);
/* harmony import */ var modules_Auth_authStore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40474);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33906);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51776);
/* harmony import */ var video_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57387);
/* harmony import */ var video_js_dist_video_js_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1717);
/* harmony import */ var video_js_dist_video_js_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(video_js_dist_video_js_css__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var videojs_contrib_quality_levels__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(58304);
/* harmony import */ var videojs_contrib_quality_levels__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(videojs_contrib_quality_levels__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var videojs_hls_quality_selector__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37482);
/* harmony import */ var videojs_hls_quality_selector__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(videojs_hls_quality_selector__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var videojs_mux__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19250);
/* harmony import */ var videojs_mux__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(videojs_mux__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _VideoPlayer_EndedOverlay__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(35472);
/* harmony import */ var lib_amplitude__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(41272);
/* harmony import */ var _courseStore__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(86036);
/* harmony import */ var lib_host__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(35304);
/* harmony import */ var videojs_youtube__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(76749);
/* harmony import */ var videojs_youtube__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(videojs_youtube__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var hls_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(42906);
/* harmony import */ var components_Toast_toastStore__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(22505);
/* harmony import */ var _mediaStore__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(13250);






// import { VideoJsPlayerOptions } from "video.js";










// import {
//   deleteVideoFromIndexedDB,
//   getVideoFromIndexedDB,
//   saveVideoToIndexedDB,
// } from "lib/video";


const VideoJS = ({ url , isHovering =false , handleInterrupt  })=>{
    const videoRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    const playerRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)(null);
    const isSubdomainTenant = (0,lib_host__WEBPACK_IMPORTED_MODULE_13__/* .useIsSubdomain */ .Do)();
    const isMoodle = (0,lib_host__WEBPACK_IMPORTED_MODULE_13__/* .useIsTenant */ .we)();
    const isMalukuTenant =  true && (0,lib_host__WEBPACK_IMPORTED_MODULE_13__/* .isMalukuURL */ .U)(window.location.hostname);
    const isGate =  true && (0,lib_host__WEBPACK_IMPORTED_MODULE_13__/* .isGateURL */ .SG)(window.location.hostname);
    // const currentLesson = useCourseStore((state) => state.currentLesson);
    const [courseStatus, courseEnrollmentId, currentLesson] = (0,_courseStore__WEBPACK_IMPORTED_MODULE_12__/* .useCourseStore */ .Kt)((state)=>[
            state.courseStatus,
            state.courseEnrollmentId,
            state.currentLesson
        ]);
    const showToast = (0,components_Toast_toastStore__WEBPACK_IMPORTED_MODULE_16__/* .useToastStore */ .E)((state)=>state.showToast);
    const [isEnded, setEnded] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const currentUserId = (0,modules_Auth_authStore__WEBPACK_IMPORTED_MODULE_2__/* .useAuthStore */ .t)((s)=>s?.currentUser?.id);
    const currentUserEmail = (0,modules_Auth_authStore__WEBPACK_IMPORTED_MODULE_2__/* .useAuthStore */ .t)((s)=>s?.currentUser?.email);
    const currentUserReferral = (0,modules_Auth_authStore__WEBPACK_IMPORTED_MODULE_2__/* .useAuthStore */ .t)((s)=>s?.currentUser?.referral);
    const lessonSlug = typeof router.query.lesson == "string" ? router.query.lesson : "";
    const courseSlug = typeof router.query.courseSlug == "string" ? router.query.courseSlug : "";
    // const { options, onReady } = props;
    const videoTitle = lessonSlug || courseSlug;
    const getVideoTitle = (title, name)=>{
        if (name) return name;
        return title.split("-").map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(" ") || "untitled";
    };
    let videoCDN = "Cloudflare";
    // let videoCDN = "Cloudfront";
    let videoStreamingType = "VOD";
    if (url?.includes("fast.gokampus.com")) videoCDN = "Fastly";
    else if (url?.includes("gokampus.cachefly.net")) videoCDN = "CacheFly";
    const currentSource = url?.includes("youtube") ? {
        src: url,
        type: "video/youtube"
    } : url?.includes("blob") ? {
        src: url,
        type: "video/mp4"
    } : {
        src: url
    };
    let playerName = "GoKampus Player";
    if (isGate) {
        playerName = "GoKampus App Player";
    }
    if (isMalukuTenant) {
        playerName = "GoKampus Maluku Player";
    }
    if (isHovering) {
        playerName += " (Hover)";
    }
    const isPpsdmAparaturTenant =  true && (0,lib_host__WEBPACK_IMPORTED_MODULE_13__/* .isPpsdmAparaturURL */ .JC)(window.location.hostname);
    const options = {
        autoplay: url !== "",
        controls: !isHovering,
        // Change to false to show playbackRates on mobile
        responsive: false,
        playsinline: true,
        // Docs: https://videojs.com/guides/options/#playbackrates
        playbackRates: [
            2,
            1.5,
            1,
            0.5
        ],
        controlBar: {
            ...isPpsdmAparaturTenant || currentUserReferral === "ppsdmaparatur" ? {} : {
                skipButtons: {
                    backward: 10,
                    forward: 10
                }
            },
            pictureInPictureToggle: true
        },
        userActions: {
            // default hotkeys:
            // - 'f' for toggle fullscreen
            // - 'space' for toggle play/pause
            // - 'm' for toggle mute
            hotkeys: true
        },
        // fluid: true,
        // https://stackoverflow.com/questions/49930680/how-to-handle-uncaught-in-promise-domexception-play-failed-because-the-use/50742427#50742427
        muted: isHovering,
        preload: true,
        sources: [
            currentSource
        ],
        plugins: {
            mux: {
                debug: false,
                data: {
                    env_key: lib_const__WEBPACK_IMPORTED_MODULE_1__/* .CONST.MUX_ENV_KEY */ .o.MUX_ENV_KEY,
                    // Metadata
                    player_name: playerName,
                    viewer_user_id: currentUserId,
                    video_id: lessonSlug,
                    video_cdn: videoCDN,
                    video_stream_type: videoStreamingType,
                    video_title: lessonSlug
                }
            }
        },
        html5: {
            hls: {
                enableLowInitialPlaylist: true,
                smoothQualityChange: true,
                overrideNative: true
            }
        }
    };
    const { setPlayerVideoJs  } = (0,_mediaStore__WEBPACK_IMPORTED_MODULE_17__/* .useMediaStore */ .Z)();
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        if (playerRef) {
            setPlayerVideoJs(playerRef);
        }
        // Make sure Video.js player is only initialized once
        if (!playerRef.current) {
            // The Video.js player needs to be _inside_ the component el for React 18 Strict Mode.
            const videoElement = document.createElement("video-js");
            videoElement.classList.add("vjs-big-play-centered");
            videoRef.current.appendChild(videoElement);
            const player = playerRef.current = (0,video_js__WEBPACK_IMPORTED_MODULE_5__["default"])(videoElement, options, ()=>{
            // videojs.log("player is ready");
            // onReady && onReady(player);
            });
            player.hlsQualitySelector({
                displayCurrentQuality: true
            });
            // Initialize quality levels
            const qualityLevels = player.qualityLevels();
            // Example: Log available quality levels
            qualityLevels.on("addqualitylevel", (event)=>{
                console.log("New quality level added:", event.qualityLevel);
            // trackEventGTM({
            //   event: "lms_video_setting_quality_a",
            //   property: {
            //     course_slug: courseSlug,
            //     lesson_slug: lessonSlug,
            //   },
            // });
            });
            // Example: Log when quality level changes
            qualityLevels.on("change", ()=>{
                const selectedQuality = qualityLevels[qualityLevels.selectedIndex];
                console.log("Selected quality level:", selectedQuality);
            // trackEventGTM({
            //   event: "lms_video_setting_quality_selected_a",
            //   property: {
            //     course_slug: courseSlug,
            //     lesson_slug: lessonSlug,
            //     quality: selectedQuality,
            //   },
            // });
            });
            // Example: Enable/disable specific quality levels
            for(let i = 0; i < qualityLevels.length; i++){
                const quality = qualityLevels[i];
                if (quality.height >= 720) {
                    quality.enabled = true;
                } else {
                    quality.enabled = false;
                }
            }
        // You could update an existing player in the `else` block here
        // on prop change, for example:
        } else {
            const player1 = playerRef.current;
            player1.autoplay(options.autoplay);
            player1.src(options.sources);
        }
    }, [
        videoRef,
        isHovering,
        url,
        playerRef
    ]);
    // const displayVideo = async () => {
    //   try {
    //     const videoBlob: any = await getVideoFromIndexedDB(videoTitle);
    //     if (videoBlob) {
    //       const url = URL.createObjectURL(videoBlob.blob);
    //       playerRef.current.src({ type: videoBlob.type, src: url });
    //     }
    //   } catch (error) {
    //     console.error("Failed to load video from IndexedDB", error);
    //   }
    // };
    let hls;
    const videoEl = videoRef.current;
    const fetchVideoFromNetwork = (url)=>{
        console.log("\uD83D\uDE80 2 url ", url);
        var dataStream = {
            video: [],
            audio: []
        };
        if (url.includes(".m3u8")) {
            if (hls_js__WEBPACK_IMPORTED_MODULE_15__/* ["default"].isSupported */ .ZP.isSupported()) {
                hls = new hls_js__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP();
                // @ts-ignore
                window.hls = hls;
                hls.loadSource(url);
                hls.attachMedia(videoEl);
                hls.on(hls_js__WEBPACK_IMPORTED_MODULE_15__/* ["default"].Events.MANIFEST_PARSED */ .ZP.Events.MANIFEST_PARSED, function(event, a) {
                    console.log("\uD83D\uDE80 3 apending data", a);
                    videoEl.play();
                    hls.on(hls_js__WEBPACK_IMPORTED_MODULE_15__/* ["default"].Events.BUFFER_APPENDING */ .ZP.Events.BUFFER_APPENDING, function(event, data) {
                        console.log("\uD83D\uDE80 3 apending", data);
                        dataStream[data.type].push(data.data);
                    });
                });
            }
        }
        console.log("\uD83D\uDE80 4 dataStream", dataStream);
    };
    const fetchVideo = (url)=>{
        fetchVideoFromNetwork(url);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        if (url) {
            console.log("\uD83D\uDE80 1", url);
            fetchVideo(url);
        }
    //  else {
    //   displayVideo();
    // }
    }, [
        url
    ]);
    // useEffect(() => {
    //   const player = playerRef.current;
    //   if (!isHovering) player.pause()
    // }, [isHovering])
    // Dispose the Video.js player when the functional component unmounts
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        const player = playerRef.current;
        let intervalId;
        let originalCurrentTime;
        let lastAllowedTime = 0;
        if (isPpsdmAparaturTenant || currentUserReferral === "ppsdmaparatur") {
            lastAllowedTime = 0;
            originalCurrentTime = player.currentTime.bind(player);
            // Override currentTime untuk block seek forward
            player.currentTime = function(time) {
                if (typeof time === "number") {
                    if (time > lastAllowedTime) {
                        return originalCurrentTime(lastAllowedTime);
                    } else {
                        lastAllowedTime = time;
                    }
                }
                return originalCurrentTime(time);
            };
            player.on("seeked", ()=>{
                player.pause();
            });
            intervalId = setInterval(()=>{
                if (!player.paused()) {
                    lastAllowedTime = player.currentTime();
                }
            }, 100);
        }
        const onPlay = ()=>{
            handleInterrupt();
            (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_11__/* .trackEventGTM */ .hk)({
                event: "lms_video_playpause_a",
                property: {
                    course_slug: courseSlug,
                    is_play: true,
                    lesson_slug: lessonSlug,
                    current_video_time: player.currentTime()
                }
            });
        };
        const onPause = ()=>{
            (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_11__/* .trackEventGTM */ .hk)({
                event: "lms_video_playpause_a",
                property: {
                    course_slug: courseSlug,
                    is_play: false,
                    lesson_slug: lessonSlug,
                    current_video_time: player.currentTime()
                }
            });
        };
        const onEnterPip = ()=>{
            (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_11__/* .trackEventGTM */ .hk)({
                event: "lms_video_pip_a",
                property: {
                    course_slug: courseSlug,
                    is_pip: true,
                    lesson_slug: lessonSlug,
                    current_video_time: player.currentTime()
                }
            });
        };
        const onLeavePip = ()=>{
            (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_11__/* .trackEventGTM */ .hk)({
                event: "lms_video_pip_a",
                property: {
                    course_slug: courseSlug,
                    is_pip: false,
                    lesson_slug: lessonSlug,
                    current_video_time: player.currentTime()
                }
            });
        };
        const onEnded = ()=>{
            setEnded(true);
            console.log("comp video");
            (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_11__/* .trackEventGTM */ .hk)({
                event: "lms_lesson_complete_a",
                property: {
                    course_slug: courseSlug,
                    lesson_slug: lessonSlug,
                    course_enrollment_id: courseEnrollmentId,
                    type: currentLesson?.type,
                    lesson_num: (0,_courseStore__WEBPACK_IMPORTED_MODULE_12__/* .getLessonNumberBySlug */ .OA)(lessonSlug, courseStatus),
                    is_marked_as_done: false,
                    marked_lesson_slug: lessonSlug
                }
            });
        };
        const onClickSeekbar = ()=>{
            (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_11__/* .trackEventGTM */ .hk)({
                event: "lms_video_timeline_a",
                property: {
                    course_slug: courseSlug,
                    lesson_slug: lessonSlug,
                    current_video_time: player.currentTime()
                }
            });
        };
        const onVolumeChange = ()=>{
            (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_11__/* .trackEventGTM */ .hk)({
                event: "lms_video_volume_a",
                property: {
                    course_slug: courseSlug,
                    lesson_slug: lessonSlug,
                    current_video_time: player.volume()
                }
            });
        };
        const onFullScreenChange = ()=>{
            (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_11__/* .trackEventGTM */ .hk)({
                event: "lms_video_fullscreen_a",
                property: {
                    course_slug: courseSlug,
                    lesson_slug: lessonSlug,
                    is_fullscreen: player.isFullscreen()
                }
            });
        };
        const onPlaybackChange = ()=>{
            const eventProperties = {
                course_slug: courseSlug,
                lesson_slug: lessonSlug,
                course_enrollment_id: courseEnrollmentId,
                type: currentLesson?.type,
                course_id: courseStatus.id,
                chapter_num: (0,_courseStore__WEBPACK_IMPORTED_MODULE_12__/* .getLessonIdBySlug */ .P_)(courseStatus.chapters, lessonSlug)?.chapterNum,
                lesson_id: (0,_courseStore__WEBPACK_IMPORTED_MODULE_12__/* .getLessonIdBySlug */ .P_)(courseStatus.chapters, lessonSlug)?.lessonId,
                lesson_num: (0,_courseStore__WEBPACK_IMPORTED_MODULE_12__/* .getLessonNumberBySlug */ .OA)(currentLesson?.slug, courseStatus),
                speed: player.playbackRate()
            };
            (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_11__/* .trackEventGTM */ .hk)({
                event: "lms_video_setting_speed_selected_a",
                property: eventProperties
            });
        };
        const onSkipBackward = ()=>{
            const eventProperties = {
                course_slug: courseSlug,
                lesson_slug: lessonSlug,
                course_enrollment_id: courseEnrollmentId,
                type: currentLesson?.type,
                course_id: courseStatus.id,
                chapter_num: (0,_courseStore__WEBPACK_IMPORTED_MODULE_12__/* .getLessonIdBySlug */ .P_)(courseStatus.chapters, lessonSlug)?.chapterNum,
                lesson_id: (0,_courseStore__WEBPACK_IMPORTED_MODULE_12__/* .getLessonIdBySlug */ .P_)(courseStatus.chapters, lessonSlug)?.lessonId,
                lesson_num: (0,_courseStore__WEBPACK_IMPORTED_MODULE_12__/* .getLessonNumberBySlug */ .OA)(currentLesson?.slug, courseStatus),
                current_video_time: player.currentTime()
            };
            (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_11__/* .trackEventGTM */ .hk)({
                event: "lms_video_backward_a",
                property: eventProperties
            });
        };
        const onSkipForward = ()=>{
            const eventProperties = {
                course_slug: courseSlug,
                lesson_slug: lessonSlug,
                course_enrollment_id: courseEnrollmentId,
                type: currentLesson?.type,
                course_id: courseStatus.id,
                chapter_num: (0,_courseStore__WEBPACK_IMPORTED_MODULE_12__/* .getLessonIdBySlug */ .P_)(courseStatus.chapters, lessonSlug)?.chapterNum,
                lesson_id: (0,_courseStore__WEBPACK_IMPORTED_MODULE_12__/* .getLessonIdBySlug */ .P_)(courseStatus.chapters, lessonSlug)?.lessonId,
                lesson_num: (0,_courseStore__WEBPACK_IMPORTED_MODULE_12__/* .getLessonNumberBySlug */ .OA)(currentLesson?.slug, courseStatus),
                current_video_time: player.currentTime()
            };
            (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_11__/* .trackEventGTM */ .hk)({
                event: "lms_video_forward_a",
                property: eventProperties
            });
        };
        player.on("play", onPlay);
        player.on("pause", onPause);
        player.on("enterpictureinpicture", onEnterPip);
        player.on("leavepictureinpicture", onLeavePip);
        player.on("ended", onEnded);
        player.on("volumechange", onVolumeChange);
        player.on("fullscreenchange", onFullScreenChange);
        player.on("ratechange", onPlaybackChange);
        // @ts-ignore
        player.controlBar?.skipBackward?.on("click", onSkipBackward);
        // @ts-ignore
        player.controlBar?.skipForward?.on("click", onSkipForward);
        // @ts-ignore
        player.controlBar?.progressControl?.seekBar?.on("click", onClickSeekbar);
        return ()=>{
            if (player && !player.isDisposed()) {
                player.off("play", onPlay);
                player.off("pause", onPause);
                player.off("enterpictureinpicture", onEnterPip);
                player.off("leavepictureinpicture", onLeavePip);
                player.off("ended", onEnded);
                player.off("volumechange", onVolumeChange);
                player.off("fullscreenchange", onFullScreenChange);
                // @ts-ignore
                player.controlBar?.progressControl?.seekBar?.off("click", onClickSeekbar);
                player.dispose();
                playerRef.current = null;
                if (isPpsdmAparaturTenant || currentUserReferral === "ppsdmaparatur") {
                    clearInterval(intervalId);
                    player.currentTime = originalCurrentTime;
                }
            }
        };
    }, [
        playerRef
    ]);
    return isEnded && !isHovering ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full h-full flex items-center relative bg-black",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_VideoPlayer_EndedOverlay__WEBPACK_IMPORTED_MODULE_10__/* .EndedOverlay */ .S, {
            onClickNext: ()=>{
                setEnded(false);
            }
        })
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        "data-vjs-player": true,
        className: "w-full h-full relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: videoRef,
                className: "w-full h-full"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "absolute top-1/2 translate-y-1/2 right-20 z-10 p-2 text-white_to_white font-bold text-c1 opacity-40 select-none",
                children: currentUserEmail
            })
        ]
    });
};


/***/ }),

/***/ 35472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ EndedOverlay; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36734);
/* harmony import */ var components_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61097);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33906);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51776);
/* harmony import */ var _courseApi__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93756);
/* harmony import */ var _courseStore__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86036);
/* harmony import */ var lib_amplitude__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41272);
/* harmony import */ var lib_currency__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(96646);
/* harmony import */ var modules_Auth_authStore__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40474);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(86880);
/* harmony import */ var lib_host__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35304);
/* harmony import */ var modules_Home_homeStore__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(88727);












const EndedOverlay = (props)=>{
    const { t  } = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)("course");
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const courseSlug = typeof router.query.courseSlug == "string" ? router.query.courseSlug : "";
    const lessonSlug = typeof router.query.lesson == "string" ? router.query.lesson : "";
    const bundleSlug = typeof router.query.lesson == "string" ? router.query.bundle : "";
    const { setCurrentTab , currentTab , setShowModalQuiz , currentCourse  } = (0,_courseStore__WEBPACK_IMPORTED_MODULE_5__/* .useCourseStore */ .Kt)((s)=>({
            setCurrentTab: s.setCurrentTab,
            currentTab: s.currentTab,
            setShowModalQuiz: s.setShowModalQuiz,
            currentCourse: s.currentCourse
        }));
    const currentUser = (0,modules_Auth_authStore__WEBPACK_IMPORTED_MODULE_7__/* .useAuthStore */ .t)((state)=>state.currentUser);
    const isEnterprisePlus = currentUser?.tenant !== undefined && [
        "Enterprise Plus",
        "Pro Plus",
        `Pro Custom (${currentUser?.referral})`
    ].includes((currentUser?.tenant)?.plan?.name);
    const courseChapters = currentCourse?.chapters || [];
    const courseSetLessonDone = (0,_courseApi__WEBPACK_IMPORTED_MODULE_4__/* .useCourseSetLessonDone */ .CH)();
    const courseGetStatus = (0,_courseApi__WEBPACK_IMPORTED_MODULE_4__/* .useCourseGetStatus */ .Pk)(courseSlug);
    const setNewLessonComplete = (0,modules_Home_homeStore__WEBPACK_IMPORTED_MODULE_10__/* .useHomeStore */ .o)((state)=>state.setNewLessonComplete);
    const isCourseFree = // @ts-ignore
    currentCourse?.discounted_price === 0 || // @ts-ignore
    currentCourse?.original_price === 0;
    const isB2B = (0,lib_host__WEBPACK_IMPORTED_MODULE_9__/* .useIsSubdomain */ .Do)() || (0,lib_host__WEBPACK_IMPORTED_MODULE_9__/* .useIsTenant */ .we)();
    const isAnyQuizLesson = currentCourse?.chapters && currentCourse?.chapters.some((a)=>a.lessons.some((x)=>x.type === "Quiz"));
    const nextLesson = (0,_courseStore__WEBPACK_IMPORTED_MODULE_5__/* .getNextLesson */ .tm)(courseChapters, lessonSlug);
    const [courseStatus, setPaywallShown, currentLesson, courseEnrollmentId, setCourseStatus] = (0,_courseStore__WEBPACK_IMPORTED_MODULE_5__/* .useCourseStore */ .Kt)((c)=>[
            c.courseStatus,
            c.setPaywallShown,
            c.currentLesson,
            c.courseEnrollmentId,
            c.setCourseStatus
        ]);
    const hasUserPaid = courseStatus?.is_paid;
    const hasPaywall = currentCourse?.is_paywall_enabled === undefined ? true : currentCourse?.is_paywall_enabled;
    const [counter, setCounter] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(1);
    // TODO: Only use if countdown being used again
    // useEffect(() => {
    //   let setCounterInterval;
    //   if ( (nextLesson?.is_free && nextLesson?.type !== "Webinar") || (!nextLesson?.is_free && hasUserPaid)) {
    //     setCounterInterval = setInterval(() => {
    //       setCounter((c) => c - 1);
    //     }, 1000);
    //   } else {
    //     clearInterval(setCounterInterval);
    //   }
    //   if(counter==0) {
    //     courseSetLessonDone.doFetch(
    //       {
    //         slug: lessonSlug,
    //       },
    //       {
    //         onSuccess(data) {
    //           courseGetStatus.doFetch({
    //             slug: courseSlug,
    //           });
    //         },
    //       }
    //     );
    //   }
    //   return () => clearInterval(setCounterInterval);
    // }, [nextLesson]);
    const redirectNextLesson = ()=>{
        props.onClickNext();
        if (nextLesson) {
            let queriesCourse = {
                ...router.query,
                courseSlug: courseSlug,
                lesson: nextLesson?.slug
            };
            /// Set showmodalquiz in store to Show Quiz directly after countdown
            if (nextLesson?.type == "Quiz" || nextLesson?.type == "Assignment") {
                setShowModalQuiz(true);
            }
            router.replace(nextLesson?.type == "Webinar" && !hasUserPaid ? {
                pathname: "/course/webinar/[courseSlug]/[lessonSlug]",
                query: {
                    ...router.query,
                    courseSlug: courseSlug,
                    lessonSlug: nextLesson?.slug
                }
            } : {
                pathname: "/course/[courseSlug]",
                query: queriesCourse
            }, undefined, {
                shallow: true
            });
        }
    };
    const getAccess = (lesson)=>{
        if (lesson?.is_free || isEnterprisePlus || hasUserPaid) return true;
        else if (lesson?.is_premium || !isEnterprisePlus) return false;
    };
    const lessonLockTenant = currentUser?.tenant !== undefined && [
        "gok-ares-enterprise-plus",
        "ppsdmaparatur"
    ].includes((currentUser?.tenant)?.slug) || [
        "gok-ares-enterprise-plus",
        "ppsdmaparatur"
    ].includes(currentUser?.referral);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        // if (counter === 0) {
        /// Hit API Course done & redirect directly after video finished
        courseSetLessonDone.doFetch({
            slug: lessonSlug
        }, {
            onSuccess (data) {
                setNewLessonComplete(true);
                courseGetStatus.doFetch({
                    slug: courseSlug
                });
                (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_6__/* .trackEventGTM */ .hk)({
                    event: "lms_video_next_a",
                    property: {
                        course_slug: courseSlug,
                        lesson_slug: lessonSlug
                    }
                });
            }
        });
        if (getAccess(nextLesson) && !lessonLockTenant) {
            redirectNextLesson();
        } else {
            redirectNextLesson();
        }
    // }
    }, [
        counter
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        // if (!isCourseFree && !nextLesson?.is_free && !hasUserPaid) {
        //   setPaywallShown(true);
        // }
        if (!isCourseFree && (!nextLesson?.is_free || !nextLesson || nextLesson?.type == "Webinar") && !hasUserPaid || !nextLesson && isCourseFree) {
            if (currentTab !== "Rekomendasi Kursus Lainnya") {
                setCurrentTab("Rekomendasi Kursus Lainnya");
                (0,lib_amplitude__WEBPACK_IMPORTED_MODULE_6__/* .trackEvent */ .L9)({
                    event: "lms_recommended_auto_a",
                    property: {
                        course_slug: courseSlug,
                        lesson_slug: lessonSlug
                    }
                });
            }
        }
    }, [
        nextLesson?.is_free,
        nextLesson?.type,
        hasUserPaid,
        isCourseFree
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        if (!nextLesson) {
            courseSetLessonDone.doFetch({
                slug: lessonSlug
            }, {
                onSuccess (data) {
                    setNewLessonComplete(true);
                    courseGetStatus.doFetch({
                        slug: courseSlug
                    }, {
                        onSuccess (data) {
                            setCourseStatus(data?.data);
                        }
                    });
                }
            });
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full h-full relative text-white_to_white bg-no-repeat bg-center bg-cover xxl-max:h-[555px] xxxl:h-[588px]",
        style: {
            backgroundImage: courseStatus?.image_cover_url ? `url(${courseStatus?.image_cover_url})` : ""
        },
        children: nextLesson?.is_free && nextLesson?.type !== "Webinar" || !nextLesson?.is_free && hasUserPaid ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "h-full w-full bg-[#000000b3] text-white_to_white absolute p-40 pl-[10%] flex flex-col items-start justify-center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "text-c1 font-light",
                    children: [
                        "Materi Selanjutnya dalam",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "font-medium",
                            children: counter
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "h-12"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "text-b1 font-medium",
                    children: nextLesson?.name
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "h-12"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex items-center gap-6",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        variant: "white",
                        className: "rounded-2",
                        onClick: ()=>{
                            redirectNextLesson();
                        },
                        children: t("startNow")
                    })
                })
            ]
        }) : !isCourseFree && (!(nextLesson?.is_free === false) || !nextLesson || nextLesson?.type === "Webinar") && !hasUserPaid && hasPaywall && !isEnterprisePlus && // Hide certificate option if b2b & doesn't have quiz type lesson
        (!isB2B || isAnyQuizLesson) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "h-full w-full bg-[#000000b3] text-white_to_white absolute p-40 pl-[10%] flex flex-col items-start justify-center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "text-b1 font-medium",
                    children: [
                        "Dapatkan Sertifikat Resmi ",
                        currentCourse?.institution?.name,
                        " hanya dengan Rp",
                        (0,lib_currency__WEBPACK_IMPORTED_MODULE_11__/* .formatCurrency */ .x)(//  @ts-ignore
                        currentCourse?.discounted_price || //@ts-ignore
                        currentCourse?.original_priceoriginal_price),
                        "!"
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "h-12"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    variant: "white",
                    className: "text-neutral-80 rounded-2",
                    onClick: ()=>{
                        setPaywallShown(true);
                    },
                    children: "Upgrade Kursus"
                })
            ]
        }) : !isCourseFree && !nextLesson && courseStatus?.course_lesson_count - courseStatus?.course_lesson_done > 1 && hasPaywall && // Hide certificate option if b2b & doesn't have quiz type lesson
        (!isB2B || isAnyQuizLesson) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "h-full w-full bg-[#000000b3] text-white_to_white absolute p-40 pl-[10%] flex flex-col items-start justify-center",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-b2",
                children: "Selesaikan pelajaranmu dan dapatkan sertifikat!"
            })
        }) : !nextLesson && courseStatus?.course_lesson_count === courseStatus?.course_lesson_done ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "h-full w-full bg-[#000000b3] text-white_to_white absolute p-40 pl-[10%] flex flex-col items-start justify-center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "text-b2",
                    children: "Materi telah selesai"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "h-12"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    variant: "white",
                    className: "text-neutral-80 rounded-2",
                    onClick: ()=>router.replace({
                            pathname: "/course/[courseSlug]",
                            query: {
                                courseSlug
                            }
                        }),
                    children: t("rewatch")
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "h-full w-full bg-[#000000b3] text-white_to_white absolute p-40 pl-[10%] flex flex-col items-start justify-center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "text-b2",
                    children: "Materi telah selesai"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "h-12"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    variant: "white",
                    className: "text-neutral-80 rounded-2",
                    onClick: ()=>router.replace({
                            pathname: "/course/[courseSlug]",
                            query: {
                                courseSlug
                            }
                        }),
                    children: t("rewatch")
                })
            ]
        })
    });
};


/***/ }),

/***/ 13250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMediaStore; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79010);

const useMediaStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)((set)=>({
        // state
        player: null,
        playerVideoJs: null,
        isPlayerReady: false,
        // actions
        setPlayer (player) {
            set({
                player
            });
        },
        setPlayerVideoJs (player) {
            set({
                playerVideoJs: player
            });
        },
        setIsPlayerReady: (isReady)=>set((state)=>({
                    isPlayerReady: typeof isReady === "function" ? isReady(state.isPlayerReady) : isReady
                }))
    }));


/***/ }),

/***/ 25893:
/***/ (function() {

/* (ignored) */

/***/ })

}]);